import React from 'react';
import { T } from '@transifex/react';
import {
  HomeOutlined,
  CalendarOutlined,
  DeleteOutlined,
  NotificationOutlined,
  ShoppingOutlined,
} from '@ant-design/icons';

import { RoutingMap } from '../../../routing/utils';

export type NavDataOptions = {
  productsEnabled?: boolean;
  notificationsEnabled?: boolean;
};

export const createNavData: (
  map: RoutingMap,
  options?: NavDataOptions
) => any[] = (
  routingMap,
  { productsEnabled = false, notificationsEnabled = false } = {}
) => [
  {
    key: 'self-service',
    title: <T _str="Overview" />,
    link: routingMap.app.selfService._,
    icon: HomeOutlined,
  },
  {
    key: 'containers',
    title: <T _str="Containers" />,
    link: routingMap.app.containers._,
    icon: DeleteOutlined,
  },
  {
    key: 'collections',
    title: <T _str="Schedule" />,
    link: routingMap.app.collections._,
    icon: CalendarOutlined,
  },
  ...(productsEnabled
    ? [
        {
          key: 'products',
          title: <T _str="Products" />,
          link: routingMap.app.products._,
          icon: ShoppingOutlined,
        },
      ]
    : []),
  ...(notificationsEnabled
    ? [
        {
          key: 'notifications',
          title: <T _str="Notifications" />,
          link: routingMap.app.notifications._,
          icon: NotificationOutlined,
        },
      ]
    : []),
];
